const updatePlayer = (state, payload) => {
  const playerIndex = state.players.findIndex((player) => { return player.id == payload.id })
  if (playerIndex == -1) return state.players

  let newPlayer = {
    ...state.players[playerIndex],
    first_name: payload.first_name,
    last_name: payload.last_name,
    birthday: payload.birthday,
    nationality: payload.nationality,
    skill_level: payload.skill_level,
    gender: payload.gender,
    region_name: payload.region_name,
    region_id: payload.region_id,
    banned: payload.banned,
    opted_out: payload.opted_out
  }

  return [
    ...state.players.slice(0, playerIndex), 
    newPlayer,
    ...state.players.slice(playerIndex + 1, state.players.length)
  ]
}

const deletePlayer = (state, payload) => {
  const playerIndex = state.players.findIndex(player => player.id == payload)
  if (playerIndex == -1) return state.players

  return [
    ...state.players.slice(0, playerIndex), 
    ...state.players.slice(playerIndex + 1, state.players.length)
  ]
}

const addView = (state, payload) => {
  return [...state.views, payload]
}

const deleteView = (state, payload) => {
  const index = state.views.findIndex(e => e.id == payload)

  return [
    ...state.views.slice(0, index),
    ...state.views.slice(index + 1, state.views.length)
  ]
}

const setCurrentViewOnDelete = (state, payload) => {
  state.currentView && state.currentView.id == payload ? false : state.currentView
}

const updateViews = (state, payload) => {
  const viewIndex = state.views.findIndex((el) => { return el.id == payload.id })
  if (viewIndex == -1) return state.views

  let newView = {
    ...state.views[viewIndex],
    id: payload.id,
    title: payload.title,
    sorting: payload.sorting,
    filters: payload.filters,
  }

  return [
    ...state.views.slice(0, viewIndex),
    newView,
    ...state.views.slice(viewIndex + 1, state.views.length)
  ]
}

const players = (state = {}, {type, payload}) => {
  switch (type) {
    case 'PLAYERS.RECEIVED':
      return {...state, ...payload}
    case 'PLAYERS.LOCATIONS_RECEIVED':
      return {...state, locations: payload.locations}
    case 'PLAYERS.REGIONS_RECEIVED':
      return {...state, regions: payload.regions}
    case 'PLAYERS.SET_LOADING':
      return {...state, isLoading: payload}
    case 'PLAYERS.PLAYER_UPDATE':
      return {...state, players: updatePlayer(state, payload), isLoading: false}
    case 'PLAYERS.PLAYER_DELETE':
      return {...state, players: deletePlayer(state, payload), isLoading: false}
    case 'PLAYERS.VIEWS_RECEIVED':
      return {...state, views: payload, isLoading: false}
    case 'PLAYERS.VIEW_CREATED':
      return {...state, views: addView(state, payload), currentView: payload,
        alert: { type: 'success', text: 'View created' }, isLoading: false}
    case 'PLAYERS.VIEW_DELETED':
      return {...state, views: deleteView(state, payload), currentView: setCurrentViewOnDelete(state, payload),
        alert: { type: 'success', text: 'View deleted' }}
    case 'PLAYERS.VIEW_UPDATED':
      return {...state, views: updateViews(state, payload.view), currentView: payload.view, isLoading: false,
        alert: payload.alert }
    case 'PLAYERS.VIEW_TITLE_UPDATED':
      return {...state, views: updateViews(state, payload.view), isLoading: false, alert: payload.alert }
    case  'PLAYERS.SHOW_ALERT':
      return {...state, alert: payload}
    case  'PLAYERS.CLEAR_ALERT':
      if (_.isEmpty(state)) return state

      return {...state, alert: null}
    case 'PLAYERS.SET_CURRENT_VIEW':
      return {...state, currentView: payload}
    case 'PLAYERS.CLEAR_CURRENT_VIEW':
      return {...state, currentView: false}
    default:
      return state
  }
}

export default players
